<template>
  <div class="user">
    <div class="photo">
      <img v-bind:src="user_image" alt="user avatar"/>
    </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" href="#">
          <span style="white-space: initial;">
            {{this.$store.state.user.fullName}}
            <!-- <b class="caret"></b> -->
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav nav-menu" v-show="!isClosed">
            <!--<li>
              <a href="#">
                <span class="sidebar-mini-icon">Mp</span>
                <span class="sidebar-normal">Mi Perfil</span>
              </a>
            </li>
            <li>
              <a href="#">
                <span class="sidebar-mini-icon">Ep</span>
                <span class="sidebar-normal">Editar Perfil</span>
              </a>
            </li>-->
            <li v-if="$store.state.connectivityState">
              <a @click="logout()" href="#">
                <span class="sidebar-mini-icon">Cs</span>
                <span class="sidebar-normal">Cerrar sesión</span>
              </a>
            </li>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions'
  import SecureLS from 'secure-ls';
  import { REVOKE_TOKEN } from 'src/api/graphql/mutations/auth/RevokeToken';

  export default {
    components: {
      CollapseTransition,
    },
    data() {
      return {
        isClosed: false,
        user_image: process.env.VUE_APP_BASE_ROUTE+'img/user.png',
      }
    },
    methods: {
      toggleMenu() {
        this.isClosed = !this.isClosed
      },
      /***
      * Función necesaria para cerrar sesión, en esta función se 
      * revoka el token y se elimina la data almacenada localmente
      */
      logout(){
        this.$store.dispatch('setLogoutState',true);
        var refreshTokenData = new SecureLS({encodingType: 'aes'});
        var myToken = refreshTokenData.get('refreshToken').data;
        this.$apollo.mutate({
            mutation: REVOKE_TOKEN,
            variables : {
                input : {
                    refreshToken: myToken,
                }
            }
        }).then((data) => {
            this.$store.dispatch('logout').then(()=>{
              this.$router.go('/login');
            });
        }).catch((error) => {
            this.$store.dispatch('setLogoutState',false);
            console.log('Ha ocurrido un error, no se pudo cerrar sesión');
        });
        
      }
    },
    mounted(){

    },
  }
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
</style>
